import { render, staticRenderFns } from "./NewOTKLicenseForm.vue?vue&type=template&id=7041e995&scoped=true"
import script from "./NewOTKLicenseForm.vue?vue&type=script&lang=js"
export * from "./NewOTKLicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041e995",
  null
  
)

export default component.exports